import { useEffect, useRef, useState } from 'react';

const zero = { days: 0, hours: 0, minutes: 0, seconds: 0 };

export function useCountdown(initialTarget: Date, onEnd?: () => void) {
  const target = useRef(initialTarget);
  const [timeLeft, setTimeLeft] = useState(zero);
  const [restartKey, setRestartKey] = useState(0);

  function calcTimeLeft() {
    const diff = target.current.getTime() - Date.now();

    if (diff <= 0) return zero;

    return {
      days: Math.floor(diff / (1000 * 60 * 60 * 24)),
      hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((diff / (1000 * 60)) % 60),
      seconds: Math.floor((diff / 1000) % 60),
    };
  }

  function restart(newTarget: Date | null = null) {
    if (newTarget) {
      target.current = newTarget;
    }

    setRestartKey((k) => k + 1);
  }

  useEffect(() => {
    setTimeLeft(calcTimeLeft());

    const timer = setInterval(() => {
      const next = calcTimeLeft();
      setTimeLeft(next);

      if (next.days === 0 && next.hours === 0 && next.minutes === 0 && next.seconds === 0) {
        clearInterval(timer);
        onEnd?.();
      }
    }, 1000);

    return () => clearInterval(timer);
  }, [restartKey]);

  return { timeLeft, restart };
}
